import React, { useMemo } from 'react';

import { Checkbox, Grid, Input, ListItemText, MenuItem, Select, Typography } from '@material-ui/core';

export default ({ onCategoryChange, selectedCategory, categoryList, isSuperAdmin }) => {
  const getSelectedLabel = (selected) => {
    if (!selected.length) return 'No Category';
    if (selected.length === 1) return selected[0];
    if (selected.length === Object.keys(categoryList).length) return 'All categories';
    return `${selected[0]} + ${selected.length - 1}`;
  };

  const availableCategories = useMemo(() => {
    const categories = ['Educational', 'Supplementary', 'Ambra Studies', 'Self Help Materials'];
    if (isSuperAdmin) return categories;
    return categories.filter((category) => category !== 'Ambra Studies');
  }, [isSuperAdmin]);

  return (
    <Grid container item alignItems="center" xs={12} sm={4}>
      <Typography>Category: &nbsp;</Typography>
      <Select
        multiple
        displayEmpty
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        value={selectedCategory}
        onChange={onCategoryChange}
        input={<Input disableUnderline />}
        renderValue={getSelectedLabel}
        MenuProps={{
          anchorOrigin: {
            horizontal: 'left',
            vertical: 'bottom',
          },
          getContentAnchorEl: null,
        }}>
        {availableCategories.map((name) => {
          const isChecked = selectedCategory.includes(name);
          return (
            <MenuItem key={name} value={name}>
              <Checkbox checked={isChecked} color="primary" />
              <ListItemText primary={name} />
            </MenuItem>
          );
        })}
      </Select>
    </Grid>
  );
};
